
<button 
    *ngIf="vehicleValue"
    [id]="vehicleValue.Id"
    class="container"
>
    <div
        [ngClass]="{ 
            'disconnected': (vehicleValue.St === 5),
            'is-selected': isSelected
        }" 
        class="container__content"
    >
        <div class="left-column">
            <div class="status-icon">
                <div
                    [ngClass]="{
                        'tk-i-driving': (vehicleValue.St === 1),
                        'tk-i-parked': (vehicleValue.St === 2),
                        'vehicle-status-no-gps': (vehicleValue.St === 3),
                        'vehicle-status-no-gsm': (vehicleValue.St === 4),
                        'tk-i-disconnected': (vehicleValue.St === 5),
                        'vehicle-status-towed': (vehicleValue.St === 6)
                    }"
                    [ngStyle]="{ transform: (vehicleValue.St === 1 ? ('rotate(' + vehicleAngle + 'deg)') : '') }"
                    class="w-5 h-5"
                ></div>
            </div>
            <tk-vehicle-control-indicator-value
                *ngIf="params?.length"
                [params]="params"
                [group]="2"
            ></tk-vehicle-control-indicator-value>
        </div>
        <div class="right-column">
            <span *ngIf="vehicleValue.St === 5" class="disconnected-status">
                {{'deviceDisconnected'|translate}}
            </span>
            <span *ngIf="vehicleValue.LastDriver" class="driver-name">
                {{ vehicleValue.LastDriver | fullName }}
            </span>
            <span [title]="vehicleValue.Nm" class="vehicle-data">
                {{ vehicleValue.Nm }}
            </span>
            <tk-vehicle-location 
                [location]="vehicleValue.LL"
                class="location"
            ></tk-vehicle-location>
        </div>

        <div *ngIf="listDataTypeVisible || isEtoll" class="param-data">
            <div *ngIf="hasBlockerReadPermissionUser && (vehicleValue?.blockerParametrId || vehicleValue?.blockerParametrIdOut2) && isBlocked" class="param-data__is-blocked">
                <i class="pi pi-lock icon"></i>
            </div>

            <app-network-type-marker [type]="vehicleValue.DN"></app-network-type-marker>

            <tk-vehicle-control-indicator-value 
                *ngIf="listDataTypeVisible !== VEHICLE_LIST_TYPE_DATA.Etoll && !isEtoll"
                [params]="params"
                [group]="listDataTypeVisible"
                class="indicator"
            ></tk-vehicle-control-indicator-value>

            <div *ngIf="listDataTypeVisible === VEHICLE_LIST_TYPE_DATA.Etoll || isEtoll">
                <ng-container *ngTemplateOutlet="etollParam"></ng-container>
            </div>
        </div>
    </div>
</button>

<ng-template #etollParam>
    <div class="flex items-center etoll-param">
        <div
            class="self-end w-4.5 h-4.5"
            title="{{vehicleValue.getEtollStatusHint()}}"
            [ngClass]="{
                'tk-i-eToll-status-unregistered' : (vehicleValue.ES === 0),
                'tk-i-eToll-status-disabled' : (vehicleValue.ES === 1),
                'tk-i-eToll-status-enabled' : (vehicleValue.ES === 2),
                'tk-i-eToll-status-error' : (vehicleValue.ES === 3),
                'tk-i-eToll-status-deleyed' : (vehicleValue.ES === 4)
            }"
        ></div>
    </div>
</ng-template>
